import React from "react";
import Container from "react-bootstrap/Container";
import Accordion from "react-bootstrap/Accordion";
import Badge from "react-bootstrap/Badge";
import Alert from "react-bootstrap/Alert";

import "bootstrap/dist/css/bootstrap.min.css";

const Update050 = () => {
  return (
    <Container className="mt-4 mb-5">
      <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
        <h2 className="m-0">Оновлення 0.5.0</h2>
        <Badge bg="success">Реалізовано</Badge>
      </div>
      <p className="text-muted">
        Версія 0.5.0: прозоріше відхилення фактур для водія, надійніші додаткові кошти й повернення VAT,
        точніше визначення водія в KSeF за датою фактури та масове створення вже оброблених рахунків на сайті.
      </p>

      <Alert variant="warning">
        <b>Перед деплоєм на прод:</b> виконати SQL-міграцію{" "}
        <code>server/migrations/alter_driver_invoices_add_rejection_reason.sql</code> і перезапустити сервер.
        Без колонки <code>rejection_reason</code> адмін не зможе зберігати причину відхилення.
      </Alert>

      <Alert variant="info">
        <b>Коротко:</b> відхиляючи фактуру, обов&apos;язково вкажіть причину — водій побачить її в кабінеті.
        Перед нарахуванням VAT у додаткові кошти є прев&apos;ю по фактурах. У KSeF водій береться з історії
        авто на дату рахунку; оброблені фактури, яких ще немає на сайті, можна створити пакетом.
      </Alert>

      <Accordion defaultActiveKey="0" alwaysOpen className="mb-4">
        <Accordion.Item eventKey="0">
          <Accordion.Header>1. Фактури водіїв — причина відхилення</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                Відхилення більше не одним кліком: спочатку кнопка <b>«Відхилити»</b>, далі поле причини
                і <b>«Підтвердити відхилення»</b>. Без тексту зберегти не можна.
              </li>
              <li>
                Ту саму причину можна вказати, якщо змінюєте статус на «Відхилена» в режимі редагування.
              </li>
              <li>
                У кабінеті водія на відхиленій фактурі з&apos;являється рядок з причиною. Інші статуси,
                кнопки й завантаження працюють як раніше.
              </li>
              <li>
                Якщо пізніше підтвердити це завантаження через KSeF або знову затвердити — причина
                очищується.
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>2. Додаткові кошти та повернення VAT</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                Список додаткових коштів фільтрується за обраним тижнем (і за водієм, якщо обрано).
                Записи більше не «зникають» через обмеження у 100 рядків.
              </li>
              <li>
                Редагування однієї клітинки більше не затирає рядки «Інше» та повернень. Сума в полі
                і розшифровка зводяться докупи.
              </li>
              <li>
                При <b>«Створити для всіх»</b> з галочкою VAT спочатку показується прев&apos;ю: скільки
                фактур, водіїв, VAT і сума повернення, з розбивкою по водіях. Ці суми потраплять у поле
                повернення ПДВ обраного тижня.
              </li>
              <li>
                Якщо галочку VAT знято — підтверджені фактури не нараховуються і лишаються зі статусом
                «Підтверджено».
              </li>
              <li>
                Нарахування VAT іде однією транзакцією: або всі обрані фактури стають «виплачені» і сума
                потрапляє в extra funds, або нічого не змінюється. Якщо VAT не нарахувався — ZUS, зарплата
                та інші поля в цьому ж запуску не застосовуються.
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>3. Як нарахувати VAT у додаткові кошти</Accordion.Header>
          <Accordion.Body>
            <ol>
              <li>
                Відкрийте <b>«Додаткові кошти»</b>, оберіть тиждень, у який треба виплатити повернення.
              </li>
              <li>
                Натисніть <b>«Створити для всіх»</b> і залиште галочку <b>VAT</b> (за потреби додайте
                ZUS, оренду тощо).
              </li>
              <li>
                Перевірте прев&apos;ю: список водіїв і фактур. Якщо все вірно — підтвердіть.
              </li>
              <li>
                Після успіху фактури стають <b>виплачені</b>, сума повернення додається в{" "}
                <code>returnVat</code> цього тижня.
              </li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>4. KSeF — водій по даті, нотатка, пакетне створення</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                Водій авта визначається на <b>календарну дату фактури</b> з історії власників. Якщо на
                цю дату в історії немає періоду — поточного водія авто більше не підставляємо (щоб не
                прив&apos;язати чужий рахунок).
              </li>
              <li>
                У записі фактури зберігається читабельний опис: дата, продавець, номер авто, номер
                фактури, KSeF, VAT і сума повернення.
              </li>
              <li>
                У картці фактури KSeF видно продавця, станцію, номер авто й позиції рахунку.
              </li>
              <li>
                Кнопка створення на сайті підписана <b>«Підтвердити»</b>. Якщо водій уже завантажив
                той самий рахунок — спочатку підтвердіть його завантаження, нову фактуру не створюйте.
              </li>
              <li>
                <b>«Створити всі оброблені на сайті»</b> бере лише фактури, уже позначені «оброблено»
                в дампі, яких ще немає у «Фактурах водіїв». Пропускаються рядки без водія на дату,
                з кількома водіями або з кількома завантаженнями — їх треба розібрати вручну.
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header>5. Як працювати з KSeF після оновлення</Accordion.Header>
          <Accordion.Body>
            <ol>
              <li>
                Відкрийте <b>«Рахунки» → «KSeF — фактури»</b>, оберіть місяць, покажіть список з дампу
                або завантажте з KSeF.
              </li>
              <li>
                Перевірте водія й номер авто. Якщо водія немає — в історії авто немає періоду на дату
                фактури; оберіть водія вручну або виправте історію в автопарку.
              </li>
              <li>
                Якщо є завантаження водія з тією ж сумою — <b>«Підтвердити завантаження водія»</b>.
              </li>
              <li>
                Якщо завантаження немає і водій однозначний — <b>«Підтвердити»</b> (створюється
                затверджена фактура на сайті).
              </li>
              <li>
                Рядки, які вже переглянули й позначили «оброблено», але ще не потрапили на сайт,
                можна добити кнопкою пакетного створення. Необроблені в пакет не входять.
              </li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="5">
          <Accordion.Header>6. Статистика тижня та рапорт</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                У статистиці тижня «Інше» і повернення більше не сумуються двічі (окремо поле і
                окремо рядки розшифровки). Береться зведена сума.
              </li>
              <li>
                У рапорті водія коректно читаються поля VAT / ZUS незалежно від регістру назви
                в базі (<code>returnVat</code> / <code>returnVAT</code>).
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="6">
          <Accordion.Header>7. Який буде результат</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>Водій розуміє, чому фактуру відхилили, і може виправити завантаження.</li>
              <li>Додаткові кошти за тиждень видно повністю, рядки «Інше» не губляться при правці.</li>
              <li>Повернення VAT нараховується прозоро, з прев&apos;ю, без подвійної виплати при збої.</li>
              <li>KSeF рідше прив&apos;язує рахунок не до того водія після зміни авто.</li>
              <li>Оброблений дамп KSeF можна швидко добити на сайт, не створюючи сумнівні рядки.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default Update050;
